export default __webpack_public_path__ + "static/media/ForbiddenAvatar.cd249fc3.svg";